// extracted by mini-css-extract-plugin
export default {"container":"EditBalanceChangeEventForm_container__ecYIp","daysOfWeekTag":"EditBalanceChangeEventForm_daysOfWeekTag__mFpMu"};